import React from "react";
import { NavLink } from "react-router-dom";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { Flame, Zap, Users, MessageCircle, User, Video } from "lucide-react";

const items = [
  { to: "/discover", labelKey: "nav.discover", icon: Flame, testid: "nav-discover" },
  { to: "/tonight", labelKey: "nav.tonight", icon: Zap, testid: "nav-tonight" },
  { to: "/moments", labelKey: "nav.moments", icon: Video, testid: "nav-moments" },
  { to: "/chats", labelKey: "nav.chats", icon: MessageCircle, testid: "nav-chats" },
  { to: "/groups", labelKey: "nav.groups", icon: Users, testid: "nav-groups" },
  { to: "/profile", labelKey: "nav.profile", icon: User, testid: "nav-profile" },
];

export default function BottomNav() {
  const { t } = useTranslation();
  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 pointer-events-none pb-[max(env(safe-area-inset-bottom),12px)] lg:hidden">
      <nav
        className="pointer-events-auto mx-auto max-w-md px-4"
        data-testid="bottom-nav"
      >
        <div
          className="flex items-center justify-between px-2 py-2.5 rounded-full border"
          style={{
            background: "rgba(22,23,26,0.78)",
            backdropFilter: "blur(28px) saturate(180%)",
            WebkitBackdropFilter: "blur(28px) saturate(180%)",
            borderColor: "rgba(16,185,129,0.35)",
            boxShadow: "0 20px 50px rgba(0,0,0,0.55), 0 0 24px -6px rgba(16,185,129,0.35), inset 0 1px 0 rgba(240,230,210,0.04)",
          }}
        >
          {items.map(({ to, labelKey, icon: Icon, testid }) => (
            <NavLink
              key={to}
              to={to}
              data-testid={testid}
              className="relative flex-1 flex flex-col items-center justify-center py-1.5 active:scale-90 transition-transform"
            >
              {({ isActive }) => (
                <>
                  {isActive && (
                    <motion.span
                      layoutId="nav-active-pill"
                      className="absolute inset-0 rounded-full"
                      style={{
                        background:
                          "radial-gradient(60% 80% at 50% 50%, rgba(201,169,97,0.18), rgba(201,169,97,0) 70%)",
                      }}
                      transition={{ type: "spring", stiffness: 400, damping: 30 }}
                    />
                  )}
                  <Icon
                    className={`relative w-[18px] h-[18px] transition-colors ${
                      isActive ? "text-[#C9A961]" : "text-[#8C867C]"
                    }`}
                    strokeWidth={isActive ? 2.4 : 1.8}
                  />
                  <span
                    className={`relative text-[9px] mt-0.5 font-medium tracking-[0.12em] uppercase transition-colors ${
                      isActive ? "text-[#F0E6D2]" : "text-[#8C867C]"
                    }`}
                  >
                    {t(labelKey)}
                  </span>
                  {isActive && (
                    <motion.span
                      layoutId="nav-active-dot"
                      className="absolute -bottom-0.5 w-1 h-1 rounded-full bg-[#C9A961]"
                      style={{ boxShadow: "0 0 8px #C9A961" }}
                      transition={{ type: "spring", stiffness: 400, damping: 30 }}
                    />
                  )}
                </>
              )}
            </NavLink>
          ))}
        </div>
      </nav>
    </div>
  );
}
